import { render, staticRenderFns } from "./MyBlocks.vue?vue&type=template&id=072a2ed4&scoped=true"
import script from "./MyBlocks.vue?vue&type=script&lang=js"
export * from "./MyBlocks.vue?vue&type=script&lang=js"
import style0 from "./MyBlocks.vue?vue&type=style&index=0&id=072a2ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a2ed4",
  null
  
)

export default component.exports